import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaBootstrapUtility from '@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';

/**
 * @const EVENTS
 * @description object mapping event names to short names for reference in this utility
 */
const EVENTS = {
  GLOBAL_READY: spartaBootstrapUtility.EVENTS.SPARTA_GLOBAL_READY,
  WIDGET_READY: 'SPARTA_WIDGET_READY.spartaWidgetUtility'
};

// Register module class with bootstrap utility when loaded

function registerModuleClass({
  moduleClass,
  moduleConfig
}) {
  console.log(`### sparta-widget-utility:registerModuleClass`, {
    moduleClass,
    moduleConfig
  });
  moduleClass.prototype.__widgetModule = true;
  spartaBootstrapUtility.registerModuleClass({
    moduleClass,
    moduleConfig
  });
}

/**
 * @class Widget
 * @description class that Widgets extend
 */
class Widget {
  /**
   * @method constructor
   * @description initialize instance of class
   */
  constructor(options = {}) {
    this.settings = options;
    const {
      name,
      version,
      id,
      loaderVersion
    } = this.widgetInfo = this.settings.widgetInfo;
    this.id = id;
    this.name = name;
    this.version = version;
    this.loaderVersion = loaderVersion;
    this.fadeInOnReady = true;
    this.widgetLoaded = false;

    // [data-sparta-container]
    this.applicationContainer = spartaStoreUtility.getData('applicationContainer', this.settings.widgetInfo);

    // expose basic sparta utilities:  events and store
    this.spartaStore = spartaStoreUtility;
    this.spartaEvents = spartaEventsUtility;
    this.widgetEvents = sparta.widgetLoader[loaderVersion].getInstance(id).events;

    // bind relevant event listeners
    this.bindSuperClassEvents();
  }

  /**
   * @property {Object} EVENTS exposes event name constant
   * @description getter for EVENTS constant
   * @returns {Object}
   */
  get EVENTS() {
    return EVENTS;
  }

  /**
   * @method bindSuperClassEvents
   * @description binds event listeners for our Widget Class
   */
  bindSuperClassEvents() {
    this.globalReadySubToken = this.spartaEvents.sub(this.EVENTS.GLOBAL_READY, this.emitWidgetReady.bind(this), false, this.settings.widgetInfo);
  }

  /**
   * @method emitWidgetReady
   * @description respond to sparta global ready event by emiting widget ready
   * @param {Object} { data, event } sparta event data and event information
   */
  emitWidgetReady() {
    if (this.widgetLoaded) return;

    // remove listener
    this.spartaEvents.unsubWidgetByToken(this.globalReadySubToken);

    // publish Widget ready event and pass Widget name and version as event.detail.widget
    this.widgetEvents.pub(this.EVENTS.WIDGET_READY, {
      widget: {
        name: this.name,
        version: this.version,
        id: this.id
      }
    });

    // trigger Widget Class widgetReady method
    this.widgetReady();

    // only add listener for refresh on first load
    if (!this.widgetLoaded) {
      this.widgetLoaded = true;

      // listen for refresh
      this.widgetEvents.sub("refreshWidget", function (event) {
        if (event.detail.name === this.name && event.detail.version === this.version) {
          this.refreshWidget(event);
        }
      }.bind(this));
    }
  }

  /**
   * @method widgetReady
   * @description finalize display of Widget now that assets are loaded and modules are initialized
   */
  widgetReady() {
    // if we are supposed to use our default fadeIn animation
    if (this.fadeInOnReady) {
      const loadingElement = this.applicationContainer.querySelector('.sparta-widget');
      loadingElement.classList.add('sparta-animate-fade-in');
      this.applicationContainer.classList.remove('sparta-widget-loading');
    }

    // remove loading gif from Widget parent
    this.removeWidgetParentSpinner();
  }

  /**
   * @method refreshWidget
   * @description Override this to implement refresh
   * @param Object event event details
   */
  refreshWidget(event) {}
  /**
   * @method destroyWidget
   * @description Override this to implement destroy
   * @param Object event event details
   */
  destroyWidget(event) {
    this.spartaEvents.unsubWidgetByToken(this.globalReadySubToken);
  }
  /**
   * @method removeWidgetParentSpinner
   * @description remove spinner loading gif from Widget parent container
   */
  removeWidgetParentSpinner() {
    const {
      name,
      version,
      id,
      loaderVersion
    } = this;
    try {
      //hideLoading is injected in the widget instance by Widget loader
      sparta.widgetLoader[loaderVersion].getInstance(id).hideLoading();
    } catch (e) {
      console.error(`Error in hiding the widget spinner. Widget name ${name}@${version}:${id}`);
    }
  }
}

export { Widget as default, registerModuleClass };
